import { render, staticRenderFns } from "./PersonalizedRanking.vue?vue&type=template&id=2a7d6e81&scoped=true&"
import script from "./PersonalizedRanking.vue?vue&type=script&lang=js&"
export * from "./PersonalizedRanking.vue?vue&type=script&lang=js&"
import style0 from "./PersonalizedRanking.vue?vue&type=style&index=0&id=2a7d6e81&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2a7d6e81",
  null
  
)

export default component.exports